import { mergeAttributes } from "@tiptap/core";
import { TableCell } from "@tiptap/extension-table-cell";

export const tableCellStyle = "min-width: 2em;"
  + "border: 1px solid black;"
  + "padding: 0.8em 0.4em 0.4em 0.4em;"
  + "vertical-align: middle;";

export default TableCell.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      "td",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { style: tableCellStyle }),
      0,
    ];
  },
});
